import { match as l_relatives } from "../../../src/params/l_relatives.js";
import { match as lang } from "../../../src/params/lang.js";
import { match as l_facilities } from "../../../src/params/l_facilities.js";
import { match as l_confirmation } from "../../../src/params/l_confirmation.js";
import { match as l_imprint } from "../../../src/params/l_imprint.js";
import { match as l_privacy } from "../../../src/params/l_privacy.js";
import { match as l_contact } from "../../../src/params/l_contact.js";
import { match as l_terms } from "../../../src/params/l_terms.js";

export const matchers = { l_relatives, lang, l_facilities, l_confirmation, l_imprint, l_privacy, l_contact, l_terms };